import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('multiSelectRoleField');

    return {
        ROLES: t('roles'),
        ROLES_ARE_REQUIRED: t('rolesAreRequired')
    };
};

export default useTranslation;
